import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "./useAxiosPrivate";
import useAuth from "./useAuth";

function AddUserAccount() {
    const [email, setEmail] = useState("");
    const axiosPrivate = useAxiosPrivate();
    const { auth } = useAuth();

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            email: email,
            disabled: false
        };
        try {
            await axiosPrivate.post(
                "/users",
                payload,
                {headers: {Authorization: "Bearer " + auth.accessToken}}
            );
            navigate("/account-users");
        } catch(err) {
            console.log(err);
        }
    }

    return (
        <form onSubmit={handleSubmit}>
            <input
                type="text"
                id="email"
                autoComplete="off"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
                required
                placeholder="Email"
                className="w-full rounded-lg border border-gray-300 px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 mb-4"
            />
            <button
                type="submit"
                className="float-right w-auto rounded-lg bg-indigo-500 hover:bg-indigo-600 px-4 py-2 text-sm text-white font-semibold shadow-md transition"
            >
                Submit
            </button>
        </form>
    )
}

export default AddUserAccount;